import React, { HTMLAttributes, useMemo } from 'react';
import './Highlight.scss';

const replaceIgnoredCharacters = (s: string) => {
	const ignoredChars = ['\'', '-'];

	ignoredChars.forEach(char => {
		s = s.replace(char, `${char}?`);
	});

	return s;
};

const makeRegExp = (s: string[]) => {
	const _words = s.map(w => {
		w = w.replace(/[\\.+*?^$[\](){}/#:!=|]/gi, '\\$&');
		w = replaceIgnoredCharacters(w);
		return w;
	});
	const words = _words.join('|');

	const regexp = new RegExp(`(${words})`, 'gi');

	return regexp;
};

const partMatches = (part: string, s?: string) => {
	if (!s) return false;

	// const regexp = makeRegExp(s.split(' '));
	const regexp = makeRegExp(s.replace(/ /g, ' ').split(' '));
	const contains = !!part.match(regexp);
	return contains;
};

interface HighlightProps extends HTMLAttributes<HTMLSpanElement> {
    query?: string;
}

const Highlight = (props: HighlightProps) => {
	const {
		query, children, className, ...rest
	} = props;

	const regexp = useMemo(() => {
		if (!query) return undefined;
		return makeRegExp(query?.trim().replace(/ +/g, ' ').split(' '));
	}, [query]);

	const parts = useMemo(() => {
		if (!children) return undefined;
		return children?.toString().split(regexp)
	}, [children, regexp]);

	if (!children) {
		return null;
	}

	const highlight = () => {
		if (query === '' || !query || children === '' || !children) return children;
		
		return (
			<span>
				{parts?.map((part, key) => {
					if (partMatches(part.trim(), query.replace(/ +/g, ' ').trim())){
						return (
							<mark key={key} className={'highlight'}>
								{part}
							</mark>
						);
					}

					return part;
				})}
			</span>
		);
	};

	const highlighted = highlight();

	return (
		<span
			className={`Highlight ${!highlighted ? 'not-highlighted' : 'highlighted'} ${className}`}
			{...rest}
		>
			{highlighted}
		</span>
	);
};

export default Highlight;
